import styled from "@emotion/styled";

export const GridWrapper = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-rows: auto 1fr;
  grid-template-columns: repeat(
    ${({ columns = 12 }) => columns},
    minmax(0, 1fr)
  );
  height: 100vh;
  height: 100dvh;
  margin: 0 auto;
`;

export const GridItem = styled.div<{
  span?: number;
  rowSpan?: number;
  hidden?: boolean;
}>`
  ${({ hidden, span = 12, rowSpan = 1 }) =>
    !hidden &&
    `grid-column: span ${span};
    grid-row: span ${rowSpan};`}
  margin: 0;
`;
